export default "__VITE_ASSET__DI3Gv8Iy__"